module.exports = __webpack_public_path__ + "img/foto-polaroid.3dc85fe8.png";